/** 设置初始化账户确认框样式类（相对 Element 默认 420px 加宽 20px） */
export const MARKET_SET_INIT_CONFIRM_CLASS = "eval-jees-market-init-confirm";

export function marketSetInitConfirmOptions(extra = {}) {
  return {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    center: true,
    customClass: MARKET_SET_INIT_CONFIRM_CLASS,
    ...extra,
  };
}



// WEBPACK FOOTER //
// ./src/view/user/eval_jees/marketConfirm.js